import React, { ComponentType } from 'react';
import { Route, RouteProps } from 'react-router';

import PageOwnerOnly from '../PageOwnerOnly/PageOwnerOnly';

export const PageOwnerRoute = ({
  children,
  component,
  ...props
}: RouteProps) => {
  const Component = component as ComponentType;
  return (
    <Route
      {...props}
      render={() => <PageOwnerOnly>{children ?? <Component />}</PageOwnerOnly>}
    />
  );
};
